import { signal, WritableSignal } from '@angular/core';
import { createInjectionToken } from 'ngxtension/create-injection-token';

export const [injectHeadingLevel, provideHeadingLevel] = createInjectionToken((baseLevel?: number | undefined) => {
    const parentLevel = injectHeadingLevel({ skipSelf: true, optional: true });
    const headingLevel: WritableSignal<number> = signal(baseLevel ?? 1 + (parentLevel?.() ?? 0));

    return headingLevel;
});
